import type { RailwayService, RailwaySession } from '@cli-types/next-adapter/railway.js'
import { outputTail } from '@cli-utils/process.js'
import { parseRailwayJson } from '@next-adapter/init/railway/runner/parse-railway-json.js'
import { runRailway } from '@next-adapter/init/railway/runner/run-railway.js'
import { parseService } from './parse-service.js'

export async function listRailwayServices(
  session: RailwaySession,
  cwd: string
): Promise<RailwayService[]> {
  const result = await runRailway(
    session.runner,
    ['service', 'list', '--environment', session.project.environmentName, '--json'],
    {
      cwd,
      mode: 'capture',
      env: session.env
    }
  )
  if (!result.success) {
    throw new Error(
      outputTail(`${result.stdout}\n${result.stderr}`) ?? 'Could not list Railway services.'
    )
  }

  const payload = parseRailwayJson<unknown>(result.stdout)
  if (!Array.isArray(payload)) {
    throw new Error('Railway returned an invalid service list response.')
  }

  const services = payload.map(parseService)
  if (services.some((service) => !service)) {
    throw new Error('Railway returned an invalid service list response.')
  }

  return services as RailwayService[]
}
